import {
  type SemanticLegendSettingsWithCategoricalConfig,
  YAxisValues,
} from '../../types';
import {
  assignmentsToColorMap,
  buildSemanticLegendAssignmentsByRunName,
} from './buildSemanticLegendAssignments';
import {type SemanticLegendPalette} from './colorPalettes';
import {type ConfigValueForRun} from './useConfigValuesAggregation';

export function getRunColorMap(
  constructedSemanticLegendData: SemanticLegendSettingsWithCategoricalConfig,
  configValuesForRunCategories: ConfigValueForRun[],
  semanticLegendPalette: SemanticLegendPalette | undefined
) {
  const categoryRunColorMap =
    constructedSemanticLegendData?.yAxisValue === YAxisValues.Config_Categories
      ? assignmentsToColorMap(
          buildSemanticLegendAssignmentsByRunName({
            configValuesForRunCategories,
            semanticLegendPalette,
            settings: constructedSemanticLegendData,
          })
        )
      : {};
  return categoryRunColorMap;
}
